export default {"src":"/_next/static/media/ftr-Logo.b9a35177.svg","height":97,"width":220,"blurWidth":0,"blurHeight":0};